import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/SuperResponsiveTableStyle.css";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "./routes/PrivateRoute";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Recuperar from "./pages/Recuperar";
import Home from "./pages/Home";
import Bills from "./pages/Bills";
import Pagos from "./pages/Pagos";
import Contact from "./pages/Contact";
import Profile from "./pages/Profile";
import MetadataProvider from "./components/MetadataProvider";
import NavBar from "./layout/NavBar";
import { WidthProvider } from "./contexts/WidthContext";
import Pagar from "./pages/Pagar";
import Metodos from "./pages/Metodos";
import Efectivo from "./pages/Efectivo";
import Oficina from "./pages/Oficina";
import Informacion from "./pages/Informacion";
import NotFound from "./pages/NotFound";
import React, { useState, useEffect, createContext } from "react";
import { http } from "./auth";
import { ThemeManagerProvider } from "./Hooks/ThemeManager";
import { Navigate } from "react-router-dom";

export const ThemeContext = createContext("light");

const PaymentGuard = ({ children, requiredType }) => {
  const [isValid, setIsValid] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const checkPaymentAccess = async () => {
      try {
        const response = await http.get(`/intranet-j/metodos-pago`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        
        const data = response.data;
        
        if (requiredType === "abonar") {
          setIsValid(data?.online?.length > 0);
        } else if (requiredType === "factura") {
          setIsValid(data?.facturas?.length > 0);
        } else {
          setIsValid(data?.online?.length > 0 || data?.facturas?.length > 0 || data?.config?.allow_advance_payment?.enabled);
        }
      } catch (error) {
        setIsValid(false);
      } 
    };

    checkPaymentAccess();
  }, [requiredType, token]);

   if (isValid === null) return null;
  
  return isValid ? children : <Navigate to="/pagos" replace />;
};

const Layout = () => {
  return (
    <>
      <NavBar>
        <Routes>
          <Route
            path="/facturas"
            element={
              <WidthProvider>
                <PrivateRoute component={Bills} />
              </WidthProvider>
            }
          />
          <Route path="/home" element={<PrivateRoute component={Home} />} />
          <Route path="/pago" element={<PrivateRoute component={Pagos} />} />
          <Route path="/contactos" element={<PrivateRoute component={Contact} />} />
          <Route path="/perfil" element={<PrivateRoute component={Profile} />} />
          <Route path="/pagos" element={<PrivateRoute component={Pagar} />} />
          
          <Route 
            path="/metodos" 
            element={
              <PrivateRoute 
                component={() => (
                  <PaymentGuard>
                    <Metodos />
                  </PaymentGuard>
                )} 
              />
            } 
          />
          
          <Route path="/efectivo" element={<PrivateRoute component={Efectivo} />} />
          <Route path="/oficina" element={<PrivateRoute component={Oficina} />} />
          <Route path="/informacion" element={<PrivateRoute component={Informacion} />} />
           <Route path="*" element={<PrivateRoute component={NotFound} />} />
        </Routes>
      </NavBar>
    </>
  );
};

function App() {
  const [theme, setTheme] = useState({});

  useEffect(() => {
    http
      .get(`/config/intranet-colors`)
      .then((response) => {
        if (response.data) {
          setTheme({
            primary: response.data.primary_color,
            secondary: response.data.secondary_color,
          });
        }
      })
      .catch((error) => {
        console.error("Error al obtener los colores:", error);
      });
  }, []);
  
  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <MetadataProvider>
        <BrowserRouter>
          <ToastContainer
            position="top-center"
            autoClose={2500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable="mouse"
            pauseOnHover
            theme="light"
            transition={Flip}
            stacked
            toastStyle={{ lineHeight: "1.2" }}
          />
          <ThemeManagerProvider initialColors={theme}> 
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/registrar" element={<Register />} />
              <Route path="/recuperar" element={<Recuperar />} />
              <Route path="/*" element={<Layout />} />
            </Routes>
          </ThemeManagerProvider>
        </BrowserRouter>
      </MetadataProvider>
    </ThemeContext.Provider>
  );
}

export default App;